let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aUqEr")).then(() => parcelRequire('7r8zn'));